<template lang="pug">
.report-root
    general-title(
        title="升降榜",
        description="帮助您对比任意两天网站流量来源的变化，可以用于网站推广渠道效果评估，从直接来源、搜索引擎、外部链接、搜索关键词等维度查找流量变化原因",
        pos="right",
        :date="timeSpan"
    )
    DateCompare(v-model="compareSpan")

    .zone
        TableTitle(icon="fa fa-list", title="榜单列表")
        div(style="padding: 20px 1.5em 0; border-top: 1px solid #e5e5e5")
            div.risefall-type
                | 请选择升降榜类型：
                v-radio-group(
                    name="compareType",
                    v-model="diffType",
                    :options="diffTypeOption",
                    class="compare-type"
                )
                select(v-model="engineType", class="se-type-select", :disabled="diffType !== 'query'")
                    option(
                        v-for="item in engineOption",
                        :key="item.name",
                        :value="item.value"
                    ) {{item.name}}
                
            table.data-table
                thead
                    tr
                        th(width="20%") 升降榜类型
                        th.right(width="20%") PV - {{ compareSpan[0] }}
                        th.right(width="20%") PV - {{ compareSpan[1] }}
                        th.right.order-ctrl(width="10%", @click="changeOrder(1)", :class="{active: whereOrder == 1}") 升(↑)
                        th.order-ctrl(width="10%", @click="changeOrder(2)", :class="{active: whereOrder == 2}") 降(↓)
                        th.order-ctrl(width="10%", @click="changeOrder(3)", :class="{active: whereOrder == 3}") 平(-)
                        th.order-ctrl(width="10%", @click="changeOrder(0)", :class="{active: whereOrder == 0}") 全部
                tbody
                    tr(v-for="item in dataList", :key="item.diffname")
                        td {{item.diffname}}
                        td.right {{item.value || '-'}}
                        td.right {{item.compareValue || '-'}}
                        td.order-text(colspan="4", v-html="item.html")
                    tr(v-show="!isListLoading && dataList.length === 0")
                        td(colspan="8", style="text-align: center;") 暂无数据
                    tr(v-show="isListLoading && dataList.length === 0")
                        td(colspan="8", style="text-align: center;")
                            img(src="//p.ssl.qhimg.com/t010aba4345b02168d6.gif")
            v-pagination(
                :total="dataList.length",
                :pn="pageNum",
                ps="10",
                @updatepage="onPageChange"
            )
</template>

<script>
import { getDateString } from '../../script/util';
export default {
    data() {
        let today = getDateString.today();
        let yestoday = getDateString.yestoday();

        return {
            timeSpan: { start: today, end: today },
            compareSpan: [ today, yestoday ],

            diffTypeOption: [
                { value: 'refer', title: '来源类型' },
                { value: 'engine', title: '搜索引擎' },
                { value: 'query', title: '搜索词' }
            ],
            diffType: 'refer',

            engineOption: [
                { name: '全部', value: 0 },
                { name: '百度', value: 1 },
                { name: '360搜索', value: 2 },
                { name: '搜狗', value: 3 },
                { name: '谷歌', value: 4 },
                { name: '必应', value: 5 }
            ],
            engineType: 0,

            whereOrder: 0,

            dataList: [],
            isListLoading: true,
            pageNum: 1
        };
    },
    computed: {
        domainId() {
            return this.$store.state.domainId;
        },
        params() {
            return {
                domainId: this.domainId,
                start: this.compareSpan[0],
                end: this.compareSpan[0],
                compareStart: this.compareSpan[1],
                compareEnd: this.compareSpan[1],
                difftype: this.diffType,
                engine: this.engineType,
                whereOrder: this.whereOrder,
                ps: 10
            };
        }
    },
    watch: {
        compareSpan([base, compared]) {
            this.timeSpan.start = base;
            this.timeSpan.end   = base;
        },
        params() {
            this.fetch();
        }
    },
    methods: {
        fetch(pageNum = 1) {
            if (!this.domainId) return;

            let whereOrder = this.whereOrder;
            this.isListLoading = true;
            this.dataList = [];

            this.$http.get('/api/report/topdiff', {
                params: _.extend({}, this.params, { pg: pageNum })
            }).then(res => {
                if (res.data.errno) {
                    this.$Modal.warn(res.data.errmsg);
                } else {
                    this.dataList = res.data.list.map(item => {
                        let diff = item.diff;
                        if (diff == null) {
                            item.html = '--';
                        } else if (diff < 0) {
                            item.html = `${diff}<span class="down-arrow">↓</span>`;
                        } else if (diff > 0) {
                            item.html = `${diff}<span class="up-arrow">↑</span>`;
                        } else {
                            item.html = diff;
                        }

                        return item;
                    });
                }
            }).catch(e => {
                this.$Modal.warn('请求错误，请稍后重试。。。');
            }).then(() => {
                this.isListLoading = false;
            });
        },
        changeOrder(order) {
            this.whereOrder = +order;
        },
        onPageChange(num) {
            this.pageNum = num;
            this.fetch(this.pageNum);
        }
    },
    created() {
        this.fetch();
    }
};
</script>

<style scoped>
@import '../../css/base/variables.css';

.zone {
    background: #fff;
    overflow: hidden;
    margin-bottom: 20px;
}

.title {
    padding: 5px 0;
    font-size: 16px;
    margin-top: 0;
    margin-bottom: 15px;
    font-weight: bold;
}
.risefall-type {
    margin-bottom: 20px;
}

.data-table {
    table-layout: fixed;
}

.data-table .order-text {
    text-align: center;
}
.data-table .order-ctrl {
    cursor: pointer;
    text-align: center;
}
.order-ctrl.active {
    background-color: var(--primary-color);
}

</style>

<style>
@import '../../css/base/variables.css';
.risefall-type .compare-type {
    display: inline-block;
    & > label {
        margin-right: 10px;
        margin-left: 0;
    }
}

.risefall-type .se-type-select {
    margin-left: 0;
}

.up-arrow {
    color: red;
}
.down-arrow {
    color: var(--primary-color);
}
.up-arrow,
.down-arrow {
    margin-left: 5px;
    font-family: Microsoft Yahei;
    font-weight: bold;
}
.datepicker{ width: 15em}
</style>



// WEBPACK FOOTER //
// risefall.vue?8fddd0d8